import { Component, Input, Output, EventEmitter, ViewChild, inject } from '@angular/core';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { CreatePricingGroupComponent } from './create-pricing-group/create-pricing-group.component';
import { UserService } from '@services/user.service';
import { CommonModule } from '@angular/common';
import { UpdatePricingGroupComponent } from './update-pricing-group/update-pricing-group.component';
import { ConfirmDialogService } from '@utils/confirm-dialog.service';
import { ToastService } from '@utils/toast.service';

@Component({
  selector: 'app-pricing-group',
  imports: [CommonModule, DrawerModule, ButtonModule, TableModule, CreatePricingGroupComponent, UpdatePricingGroupComponent],
  templateUrl: './pricing-group.component.html',
  styleUrl: './pricing-group.component.scss',
})
export class PricingGroupComponent {
  private userService = inject(UserService);
  private confirmDialogService = inject(ConfirmDialogService);
  private toastService = inject(ToastService);

  @Input() createDrawerVisible: boolean = false;
  @Output() createDrawerVisibleChange = new EventEmitter<boolean>();

  @Input() updateDrawerVisible: boolean = false;
  @Output() updateDrawerVisibleChange = new EventEmitter<boolean>();

  public isDeleting = false;
  public listPricingGroup: any[] = [];
  public pricingGroupIdEditing: any = null;

  ngOnInit(): void {
    this.loadPricingGroupData();
  }

  loadPricingGroupData(): void {
    this.userService.listPricingGroup().then((response: any) => (this.listPricingGroup = response.content));
  }

  updatePricingGroup(id: any): void {
    this.pricingGroupIdEditing = id;
    this.updateDrawerVisible = true;
    this.updateDrawerVisibleChange.emit(this.updateDrawerVisible);
  }

  delete = (event: Event, id: any) => {
    this.isDeleting = true;

    this.confirmDialogService
      .dialog(event, 'Al eliminar este grupo de precios, los usuarios se desasociarán de él.', 'Continuar', 'Cancelar')
      .then(() => {
        this.userService
          .deletePricingGroup(id)
          .then(() => {
            this.toastService.success('Grupo de precios eliminado con éxito.');
            this.ngOnInit();
          })
          .catch((error: any) => {
            this.toastService.error(error.error.data.message);
            this.isDeleting = false;
          });
      })
      .catch(() => (this.isDeleting = false));
  };
}
